export const DateTimeInputClear = {
  mounted() {
    this.el.addEventListener("keydown", (e) => {
      if (e.key === "Delete" || e.key === "Backspace") {
        this.el.value = ""
        this.el.dispatchEvent(new Event("input", { bubbles: true }))
      }
    })
  },
}
